module.exports = __webpack_public_path__ + "static/img/order_icon0.80268a0f.svg";